/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Drive_Workbook_RequiredInputs */

const fr_api_drive_workbook_required = /** @type {(inputs: Api_Drive_Workbook_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisissez d’abord le fichier de retenue dans les paramètres Drive.`)
};

const en_api_drive_workbook_required = /** @type {(inputs: Api_Drive_Workbook_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose the withholding workbook in Drive settings first.`)
};

/**
* | output |
* | --- |
* | "Choose the withholding workbook in Drive settings first." |
*
* @param {Api_Drive_Workbook_RequiredInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const api_drive_workbook_required = /** @type {((inputs?: Api_Drive_Workbook_RequiredInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Drive_Workbook_RequiredInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_drive_workbook_required(inputs)
	return fr_api_drive_workbook_required(inputs)
});